/**
 * SmartMessageSignModal — dialog host for signing a smart-message signature block.
 *
 * Wraps the existing SignatureWidget (which handles setup, method-specific
 * signing, and the signed state on its own). When the signature lands —
 * including when the parent already signed for a sibling — `onSigned` fires so
 * the caller can record the block response and close.
 *
 * @module features/messaging/components/SmartMessageSignModal
 */

import { XMarkIcon } from '@heroicons/react/24/outline';
import SignatureWidget from '@/features/signing/components/SignatureWidget';

export default function SmartMessageSignModal({ documentId, documentTitle, onSigned, onClose }) {
  if (!documentId) return null;

  return (
    <div className="modal modal-open" role="dialog" data-testid="smart-message-sign-modal">
      <div className="modal-box max-w-lg p-6">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <h3 className="font-semibold text-base-content">
              {documentTitle || 'Sign document'}
            </h3>
            <p className="text-sm text-base-content/60 mt-0.5">
              Your signature is recorded once and applies to this message.
            </p>
          </div>
          <button
            type="button"
            className="btn btn-ghost btn-sm btn-circle flex-shrink-0"
            onClick={onClose}
            aria-label="Close"
            data-testid="sign-modal-close"
          >
            <XMarkIcon className="w-5 h-5" aria-hidden="true" />
          </button>
        </div>

        <SignatureWidget
          documentId={documentId}
          documentTitle={documentTitle}
          onSigned={onSigned}
        />
      </div>
      <div className="modal-backdrop bg-black/40" onClick={onClose} />
    </div>
  );
}
